import { AcquireHealthCardNumberState } from "./type";

export const getHealthCardNumberAcquisitionMode = (state: AcquireHealthCardNumberState) => {
     return state.acquiringMode;
}

export const getNumberOfRegionCodeNumberOfSubmitAttempts = (state: AcquireHealthCardNumberState) => state.postalCodeNumberOfAttempts;

export const getInvalidHealthCardNumberDetected = (state: AcquireHealthCardNumberState) => state.invalidHealthCardNumberDetected;

export const getShowPostalCodeVerificationModal = (state: AcquireHealthCardNumberState) => state.showPostalCodeConfirmationModal;

export const getIncorrectRegionCodeDetected = (state: AcquireHealthCardNumberState) => state.invalidPostalCodeDetected;


// WEBPACK FOOTER //
// ./src/store/AcquireHealthCardNumber/selectors.ts